<template>
  <div class="communication-form-problem view-box">
    <div class="title">{{ option.title }}</div>
    <div class="record">
      <div class="problem-title"><span>问题记录</span></div>
      <div class="record-value bt-border">
        {{ option.record.value || '无问题反馈' }}
      </div>
      <div class="problem-title">
        <span class="required">记录是否准确</span>
        <radio-group
          v-model="option.record.recordAccurate"
          direction="horizontal"
        >
          <radio name="1" icon-size="16px" checked-color="#FF6F00">是</radio>
          <radio name="0" icon-size="16px" checked-color="#FF6F00">否</radio>
        </radio-group>
      </div>
      <!--      <div-->
      <!--        class="record-desc bt-border"-->
      <!--        v-if="option.record.recordAccurate !== '1'"-->
      <!--      >-->
      <!--        <span>-->
      <!--          正确问题描述：-->
      <!--        </span>-->
      <!--        <field-->
      <!--          v-model="option.record.desc"-->
      <!--          rows="2"-->
      <!--          ref="field"-->
      <!--          autosize-->
      <!--          type="textarea"-->
      <!--          :maxlength="300"-->
      <!--          placeholder="写出您的服务感受，可以帮助更多商户哦~"-->
      <!--          show-word-limit-->
      <!--        />-->
      <!--      </div>-->
    </div>
    <!--    <div class="title" style="margin-top: 16px; margin-bottom: 25px;">-->
    <!--      问题解决情况-->
    <!--    </div>-->
    <!--    <div class="solve-situation">-->
    <!--      <steps-->
    <!--        direction="vertical"-->
    <!--        :active="0"-->
    <!--        active-icon="stop-circle-o"-->
    <!--        active-color="#FF8A01"-->
    <!--        inactive-color="#ccc"-->
    <!--      >-->
    <!--        <step-->
    <!--          v-for="stepItem in option.solveTheSituation.step"-->
    <!--          :key="stepItem.status"-->
    <!--        >-->
    <!--          <div class="info">-->
    <!--            <div class="status">-->
    <!--              <span>-->
    <!--                {{ stepItem.status }}-->
    <!--              </span>-->
    <!--              <b-->
    <!--                v-if="-->
    <!--                  stepItem.status === '已完成' && option.evaluate.value === '1'-->
    <!--                "-->
    <!--                @click="-->
    <!--                  $router.replace({-->
    <!--                    name: 'communication-evaluate',-->
    <!--                    query: {-->
    <!--                      id: option.id,-->
    <!--                    },-->
    <!--                  })-->
    <!--                "-->
    <!--                class="evaluate-btn"-->
    <!--                >去评价</b-->
    <!--              >-->
    <!--            </div>-->
    <!--            <div class="time">{{ stepItem.time }}</div>-->
    <!--          </div>-->
    <!--        </step>-->
    <!--      </steps>-->
    <!--      <div class="solve-situation-desc field-details" style="margin-top: 20px;">-->
    <!--        <div class="label">完成说明</div>-->
    <!--        <div class="value">{{ option.solveTheSituation.desc }}</div>-->
    <!--      </div>-->
    <!--      <div-->
    <!--        class="solve-situation-images field-details bt-border"-->
    <!--        style="margin-top: 20px; padding-bottom: 17px;"-->
    <!--      >-->
    <!--        <div class="label">完成照片</div>-->
    <!--        <div class="value">-->
    <!--          <div class="img-list">-->
    <!--            <img-->
    <!--              v-for="(img, idx) in option.solveTheSituation.images.split(',')"-->
    <!--              :key="idx"-->
    <!--              :src="img"-->
    <!--              @click="imagePreview(listIdx, idx)"-->
    <!--            />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="title" style="margin-top: 16px; margin-bottom: 25px;">-->
    <!--      问题处理评价-->
    <!--      <b class="evaluate-btn">重新评估</b>-->
    <!--    </div>-->
    <!--    <div class="evaluate">-->
    <!--      <div class="result">-->
    <!--        <img-->
    <!--          :src="require('../../assets/img/communication/logo_wpxe.png')"-->
    <!--          class="img"-->
    <!--        />-->
    <!--        <span>{{ option.evaluate.result }}</span>-->
    <!--      </div>-->
    <!--      <div class="details field-details">-->
    <!--        <div class="label">完成照片</div>-->
    <!--        <div class="value">-->
    <!--          {{ option.evaluate.detail }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { ImagePreview } from 'vant';

import 'vant/lib/radio-group/style';
import 'vant/lib/radio/style';
// import 'vant/lib/field/style';
// import 'vant/lib/step/style';
// import 'vant/lib/steps/style';

export default {
  name: 'Problem',

  mixins: [],

  components: {
    RadioGroup: () => import('vant/lib/radio-group'),
    Radio: () => import('vant/lib/radio'),
    // Field: () => import('vant/lib/field'),
    // Step: () => import('vant/lib/step'),
    // Steps: () => import('vant/lib/steps'),
  },

  props: {
    option: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {};
  },

  computed: {},

  watch: {
    'option.record.recordAccurate'() {
      this.option.record.desc = '';
    },
  },

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 图片预览
     * @param listIdx srcUrl数组
     * @param startPosition 数组下标
     */
    imagePreview(listIdx, startPosition) {
      ImagePreview({
        images: this.option.solveTheSituation.images.split(','),
        startPosition,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.communication-form-problem {
  padding: 16px 14px;
  & > div {
    width: 100%;
  }
  .bt-border {
    border-bottom: 1px solid #e4e4e4;
  }
  .evaluate-btn {
    display: block;
    padding: 4px 17px;
    box-sizing: border-box;
    background: #ffeaee;
    border-radius: 10px;
    font-size: 12px;
    color: #FF6F00;
  }
  .field-details {
    width: 100%;
    display: flex;
    .label {
      width: 56px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      margin-right: 8px;
      padding: 0;
    }
    .value {
      flex: 1;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      text-align: left;
      .img-list {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        img {
          width: 75px;
          height: 75px;
          margin-right: 5px;
          margin-bottom: 5px;
          border-radius: 4px;
        }
      }
    }
  }
  .problem-title {
    display: flex;
    justify-content: space-between;
    margin: 16px 0;
    position: relative;

    & /deep/ .van-radio__label {
      font-size: 14px;
    }

    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      text-align: left;
      color: #666666;
      line-height: 20px;
      & :before {
        content: '* ';
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF6F00;
      }
    }
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #333333;
    line-height: 16px;
    text-align: left;
  }
  .record {
    .record-value,
    .record-desc {
      padding-bottom: 14px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
      text-align: left;
      & /deep/ .van-field {
        width: 100%;
        height: 100px;
        border-radius: 4px;
        margin-top: 16px;
        border: 1px solid #cccccc;
        padding: 4px 9px 8px 8px;
        .van-field__value {
          display: flex;
          flex-direction: column;
          .van-field__word-limit {
            margin-top: 0;
            color: #ccc;
          }
          .van-field__body {
            flex: 1;
            .van-field__control {
              width: 100%;
              height: 100% !important;
            }
          }
        }
      }
    }
  }
  .solve-situation {
    & /deep/ .van-steps.van-steps--vertical {
      .van-step__circle-container {
        // position: relative;
        width: 16px;
        height: 16px;
        font-size: 16px;
        background: #eee;
        border-radius: 50px;
        i {
          display: none;
        }
        &::before {
          content: '';
          position: absolute;
          width: 8px;
          height: 8px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #ccc;
          border-radius: 50px;
        }
      }

      .van-step__title--active + .van-step__circle-container {
        background: #fba8b5;
        &::before {
          background: #FF6F00;
        }
      }
      .van-step__line {
        width: 0;
        border: 1px dashed #e9e9e9;
      }

      .van-steps__items > div:last-child .van-step__line {
        display: none;
      }

      [class*='van-hairline']::after {
        border: none;
      }

      .van-step {
        .info {
          width: 100%;
          .status {
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 20px;
            }
          }
          .time {
            font-weight: 400;
            color: #999999;
            line-height: 17px;
            text-align: left;
          }
        }
      }
    }

    .solve-situation-desc,
    .solve-situation-images {
    }
  }
  .evaluate {
    width: 100%;
    .result {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 17px;
      .img {
        width: 40px;
        height: 40px;
        margin-bottom: 6px;
      }
    }
    .details {
    }
  }
}

.required {
  position: relative;
  &:before {
    content: '*';
    margin-right: 2px;
    color: #FF6F00;
  }
}
</style>
